/* HTTP TripPoints repository — talks to the real backend (API_CONTRACT.md). */
import { apiDelete, apiGet, apiSend } from './httpClient'
import type { CreatePointInput, TripPoint, UpdatePointInput } from './types'

export function listPoints(tripId: string): Promise<TripPoint[]> {
  return apiGet<TripPoint[]>(`/trips/${tripId}/points`)
}

export function addPoint(tripId: string, input: CreatePointInput): Promise<TripPoint> {
  return apiSend<TripPoint>('POST', `/trips/${tripId}/points`, input)
}

export function updatePoint(
  tripId: string,
  pointId: string,
  patch: UpdatePointInput,
): Promise<TripPoint> {
  return apiSend<TripPoint>('PATCH', `/trips/${tripId}/points/${pointId}`, patch)
}

export function deletePoint(tripId: string, pointId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/points/${pointId}`)
}

export function reorderPoints(tripId: string, orderedIds: string[]): Promise<TripPoint[]> {
  return apiSend<TripPoint[]>('POST', `/trips/${tripId}/points/reorder`, {
    ordered_ids: orderedIds,
  })
}
